import { BaseModel, type RelationConfig } from './base';

import { Order } from './order';
import { ReservationCustomer } from './reservationCustomer';

// Helper Classes

export class FrontDeskReservationCustomerCheckin extends BaseModel {
  order!: Order | null;
  reservationCustomer!: ReservationCustomer | null;

  static override relations(): RelationConfig {
    return {
      order: { type: Order },
      reservationCustomer: { type: ReservationCustomer },
    };
  }
}

// Main Model

export class FrontDesk extends BaseModel {}
